import React from 'react';
import { useIntl } from 'react-intl';
import { BeneficiariesContent } from '../../components/organims/BeneficiariesContent';

export const LegalBeneficiaries = () => {
  const { messages: intlMessages } = useIntl();

  return <BeneficiariesContent contactType="legal" emptyContentMessage={intlMessages['beneficiaries.legalEmptyContentMessage']} />;
};
